<template>
  <div>
    <a v-bind:class="['close-trip-summary' + (showTripDetails? ' show': '')]"
       v-on:click="toggleTripDetails" href="javascript:;">
      <icon name="remove"></icon>
    </a>
    <div class="trip-details-header"
         v-on:click="toggleTripDetails">
      <span v-if="showTripDetails" class="trip-details-header-text">{{ $t('rsvpDetails.hideTrip') }}</span>
      <span v-else class="trip-details-header-text">{{ $t('rsvpDetails.showTrip') }}</span>
      <span v-if="showTripDetails" class="trip-details-header-icon"><icon name="caret-down"></icon></span>
      <span v-else class="trip-details-header-icon"><icon name="caret-up"></icon></span>
    </div>
    <div v-bind:class="['trip-details card padding-a-z margin-b-l' + (showTripDetails?' show': '')]">
      <h2 class="margin-a-z padding-t-m padding-l-m">{{ $t('rsvpDetails.tripSummary') }}</h2>
      <div v-if="showRoundTripTab">
        <ul class="tab">
          <li v-on:click="switchLegTabs" :class="[(leg1Tab? 'active':'')]">{{ $t('common.leg') }} 1</li>
          <li v-on:click="switchLegTabs" :class="[(leg2Tab? 'active':'')]">{{ $t('common.leg') }} 2</li>
        </ul>
        <div class="tab-border"></div>
      </div>
      <div class="tab-contents">
        <div v-bind:class="['tab-content' + (leg1Tab? ' active':'')]">
          <reservation-details-header
            :key="rsvpDetailsHeaderKey"
            :leg="leg1" currentLeg="leg1" v-if="rerender"
            :user="user" :brand="brand" :flash="flash" :otherLeg="leg2">
          </reservation-details-header>
        </div>

        <div v-bind:class="['tab-content' + (leg2Tab? ' active':'')]">
          <reservation-details-header :leg="leg2" currentLeg="leg2" v-if="rerender"
            :user="user" :brand="brand" :flash="flash" :otherLeg="leg1">
          </reservation-details-header>
        </div>

      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import ReservationDetailsHeader from './ReservationDetailsHeader.vue'
import moment from 'moment'

export default {
  name: 'reservation-details',
  props: [ 'flash', 'leg1', 'leg2', 'user', 'brand', 'rerender' ],
  data () {
    return {
      showTripDetails: false,
      leg1Tab: true,
      leg1Info: {},
      leg2Tab: false,
      leg2Info: {},
      rsvpDetailsHeaderKey: moment().format('x')
    }
  },
  components: { 'reservation-details-header': ReservationDetailsHeader },
  watch: {
    leg1 (val) {
      if (val && val.pickupText) {
        this.leg1Info = Object.assign({}, this.leg1Info, val)
      }
    },
    leg2 (val) {
      this.leg2Info = {}
      if (val && val.pickupText) {
        this.leg2Info = Object.assign({}, this.leg2Info, val)
      } else {
        this.leg1Tab = true
        this.leg2Tab = false
      }
    },
    rerender (val) {
      this.$forceUpdate()
      this.rsvpDetailsHeaderKey = moment().format('x')
    }
  },
  computed: {
    // showRoundTripTab () { return (Object.keys(this.leg2Info).length > 0) }
    showRoundTripTab () { return this.$store.state.reservation.isRoundtrip }
  },
  methods: {
    toggleTripDetails () { this.showTripDetails = !this.showTripDetails },
    switchLegTabs () {
      if (this.leg1Tab) {
        this.leg1Tab = false
        this.leg2Tab = true
      } else {
        this.leg1Tab = true
        this.leg2Tab = false
      }
    },
    addZero: function (val) {
      return parseInt(val).toFixed(2)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/scss/Tab.scss";
@import "../../assets/scss/Reservation/ReservationDetails.scss";
h2{
  font-size: 1.5em!important;
  font-weight: 600!important;
}
</style>



// WEBPACK FOOTER //
// ReservationDetails.vue?3983cde5